import { FC, PropsWithChildren } from 'react'
import { Navigate, useLocation, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { getUser } from 'redux/store/user/getters'
import {
  buildContractDetailsPath,
  canSeeMyContracts,
  isContractUuid
} from 'helper/common'

/**
 * Contract details routes are /contracts/:type/:id (e.g. type = my_contracts).
 * Deep links from emails use /contracts/:contractId/... so :type is the UUID and :id is a tab name.
 * Users with "My contracts" only work on /contracts/my_contracts/:id — redirect before details load.
 */
export const ContractDetailsMyContractsRedirect: FC<PropsWithChildren> = ({
  children
}) => {
  const user = useSelector(getUser)
  const { pathname } = useLocation()
  const { type, id, tab, subtab } = useParams()

  if (canSeeMyContracts(user.role) && isContractUuid(type)) {
    // Re-map /contracts/{uuid}/[tab]/[subtab] → /contracts/my_contracts/{uuid}/[tab]/[subtab].
    const target = buildContractDetailsPath(user.role, type, id, subtab ?? tab)

    if (pathname !== target) {
      return <Navigate to={target} replace />
    }
  }

  return <>{children}</>
}
